export default "__VITE_ASSET__BDjNXmcu__"